import { render, staticRenderFns } from "./EditKelas.vue?vue&type=template&id=68d8c867&"
import script from "./EditKelas.vue?vue&type=script&lang=js&"
export * from "./EditKelas.vue?vue&type=script&lang=js&"
import style0 from "./EditKelas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports